var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{attrs:{"body-style":{ padding: 4 },"bordered":false,"head-style":{ borderBottom: 0 },"size":"small","title":_vm.title}},[_c('line-chart',{attrs:{"height":280,"chartData":_vm.chartData,"datetime-range":_vm.datetimeRange,"chartId":_vm.chartId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }